/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm, replacePXinStringWithEM } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// STRUCTURE : MESSAGE HOLDER : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
    messageHolder: {
    	'& .messages': {
    		display: 'flex',
    		flexDirection: 'column',
    		width: '100%',
    		position: 'fixed',
    		zIndex: '100000000', /// on top of everything
    		'&.top': {
    			top: '0'
    		},
    		'&.bottom': {
    			bottom: '0',
    			flexDirection: 'column-reverse',
    		},
    	}
    }
});